import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const AsOfDate = (props) => {
  const { cancelPopUp, setCancelPopUp, title, submit } = props;
  const [asOfDate, setAsOfDate] = useState(null);

  const handleCancel = () => {
    setCancelPopUp(false);
  };

  const handleSubmit = () => {
    if (asOfDate) {
      setCancelPopUp(false);
      submit(asOfDate);
    }  
  };

  return (
    <Dialog fullWidth={true} maxWidth={'xs'} open={cancelPopUp}>
      <DialogTitle>
        <Typography variant="h5">
          {title}
        </Typography>  
      </DialogTitle>
      <DialogContent dividers>
        <TextField
          id="asOfDate"
          label="As of Date"
          value={asOfDate}
          type="date"
          InputLabelProps={{
            shrink: true,
          }}
          onChange={(event) => {
            setAsOfDate(event.target.value);
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={handleCancel}>
          Cancel
        </Button>
        <Button variant='contained' onClick={handleSubmit}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AsOfDate;
